"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgPartlyCloudyNight = function SvgPartlyCloudyNight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M14.569 8.933A4 4 0 0112 16H4a4 4 0 01-1.881-7.53 4.502 4.502 0 014.905-3.44c.216-2.1 1.906-3.79 4.064-4.024a1 1 0 011.05 1.328c-.092.26-.14.533-.14.815 0 1.38 1.159 2.51 2.6 2.51.098 0 .197-.005.294-.015a1 1 0 011.05 1.328 4.504 4.504 0 01-1.373 1.961zm-5.6-3.195A4.504 4.504 0 0110.744 8h.854c.607 0 1.172-.203 1.62-.547-1.754-.54-3.06-2.085-3.206-3.953A2.484 2.484 0 009 5.49c0 .085-.01.168-.031.248zM9.965 10a1 1 0 01-.99-.858 2.5 2.5 0 00-4.964.118 1 1 0 01-.667.85A2.001 2.001 0 004 14h8a2 2 0 100-4H9.965z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

SvgPartlyCloudyNight.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgPartlyCloudyNight;
exports.default = _default;